import React, { Component } from "react";
import SubmitFeed from "./Elements/SubmitFeed";
import { isAppleSafari, isPersAcc, showAddAccountAlertNew, TOAST_ERROR, isAccountConnected } from "../../../../../../../../../utils";
import { addUserAccount } from "../../../../../../../../Authorization/SocialAuth/connectSocialAcc";
import { MediaBaseUrl } from "../../../../../../../../../actions/api";
import { connect } from 'react-redux';
import ConnectChildAccount from "./Elements/ConnectChildAccount";
import InputField from "./Elements/InputField";
import { sourceInfoMsg } from "../../../../SelectSource/Elements/NetworkMsg";
import { FontAwesomeIcon } from "../../../../../../../../CommonComponents/AssetsHelper";

const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class InstaFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hashtag: '',
            handle: '',
            error: false,
            hanldeError: false,
            feedObj: {},
            accountList: []
        }
    }

    componentDidMount() {
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    onChangeHandler = event => {
        this.setState({ [event.target.name]: event.target.value, error: false, handleError: false });
    }

    addInstaAccount = () => {
        const { selectedFilterId } = this.props;
        const feed = this.createFeedPostData();
        const isPer = isPersAcc(selectedFilterId);
        this.setState({ feedObj: feed });
        showAddAccountAlertNew({ id: isPer ? 2 : 18, name: isPer ? 'instagram' : 'facebook' }, "addFeed", [23, 26, 24].includes(selectedFilterId) ? true : null);
    }

    createFeedPostData = () => {
        const { hashtag, handle } = this.state;
        const { selectedFilterId, accountId } = this.props;
        const isPer = isPersAcc(selectedFilterId);
        var obj = {
            networkId: isPer ? 2 : 18,
            feedText: selectedFilterId == 26 ? hashtag.split('#').join('') : selectedFilterId == 23 ? handle.split('@').join('') : '',
            hashtagCaption: 0,
            filter: selectedFilterId,
            accountId: accountId,
            hashtagIGTV: 0,
            onlyReels: 0,
            moderation: 0,
        }

        return obj;
    }

    createFeed = (connectAccountId) => {
        const { updateStep } = this.props;
        let obj = this.createFeedPostData();
        if (connectAccountId != null) {
            obj = { ...obj, accountId: connectAccountId }
        }

        this.setState({ loading: true, error: false, handleError: false });

        updateStep(2, obj, () => this.setState({ loading: false }));
    }

    onSubmit = (isDisabledClick) => {
        const { hashtag, handle, accountList } = this.state;
        const { accountId, selectedFilterId, connectedAcc } = this.props;

        const isAccConnected = isAccountConnected({ connectedAcc, accountList, accountId });

        if ([34, 24, 25, 88, 66, 1].includes(selectedFilterId) && !isAccConnected) {
            TOAST_ERROR("Please connect your Instagram Account to proceed");
            return;
        }

        if ((hashtag.trim().length == 0) && selectedFilterId == 26) {
            this.setState({ error: true, loading: false })
            if (isDisabledClick) {
                TOAST_ERROR('Please enter a hashtag');
            }
        } else if ((handle.trim().length == 0) && selectedFilterId == 23) {
            this.setState({ handleError: true, loading: false })
            if (isDisabledClick) {
                TOAST_ERROR('Please enter a handle');
            }
        } else {
            if ([23, 26].includes(selectedFilterId)) {
                this.createFeed(accountId != null ? accountId : 0);
            } else {
                if (accountId) {
                    this.createFeed(null);
                } else {
                    this.addInstaAccount();
                }
            }
        }
    }

    createFeedFromPage = (accId, parentId, name) => {
        const { updateStep } = this.props;
        let { feedObj } = this.state;

        if ([34, 24, 25, 66, 88].includes(parseInt(feedObj.filter))) {
            feedObj.feedText = name;
            feedObj.accountId = accId;
        } else {
            feedObj.accountId = parentId;
        }

        this.setState({ loading: true, error: false, handleError: false });

        updateStep(2, feedObj, () => this.setState({ loading: false }));

    }


    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId, type } = response;
        const { selectedFilterId } = this.props;

        if (type == "addFeed") {
            let callbackFun = (responseData) => this.setState({ accountList: responseData });
            if (![24, 88].includes(parseInt(selectedFilterId))) {
                callbackFun = (connectAccountId) => this.createFeed(connectAccountId);
            }
            addUserAccount(networkId, data, callbackFun, localStorage.getItem('ownerId'), selectedFilterId);
        }
    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }


    render() {
        const { hashtag, handle, error, handleError, loading, accountList } = this.state;
        const { selectedFilterId, connectedAcc, selectedNetworkId } = this.props;
        const isPer = isPersAcc(selectedFilterId);
        const infoMsg = sourceInfoMsg(selectedNetworkId, selectedFilterId);

        const isSubmitDisabled = selectedFilterId == 26 ? !hashtag.trim()
            : selectedFilterId == 23 ? !handle.trim()
                : false;

        return (
            (accountList && accountList.length > 0) && [34, 24, 25, 88, 66, 1].includes(selectedFilterId) ?
                <ConnectChildAccount accountList={accountList} loading={loading} connectedAcc={connectedAcc} networkId={isPer ? 2 : 18} createFeedFromPage={this.createFeedFromPage} backAction={this.props.backAction} /> : <div className="ob-feed-form-wrapper w-100">
                    {[34, 24, 25, 66, 1, 88].includes(selectedFilterId) ? <><div className="form-group text-start mb-3">
                        <div className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3 cursor-pointer" onClick={this.addInstaAccount}>
                            <span className="symbol symbol-25 me-3">
                                <img src={`${MediaBaseUrl}social-icons/instagram.svg`} />
                            </span>
                            <span className="text-dark-50 font-weight-bolder font-size-base">Connect Instagram</span>
                        </div>
                    </div>
                        {selectedFilterId == 24 ? <p style={{ fontSize: "12px", color: '#9e9c9c' }}>You will only get upcoming posts after creating Mentions feed.</p> : null} </>
                        :
                        <>
                            <div className="ob-input-block mb-3">
                                <div className="form-group position-relative advance-input">
                                    <div className="position-relative d-flex">
                                        <span className="hastag d-flex align-items-center">
                                            <i className={`fas fa-${selectedFilterId == 26 ? "hashtag" : "at"}`}></i>
                                        </span>
                                        <InputField name={selectedFilterId == 26 ? "hashtag" : "handle"} placeholder={selectedFilterId == 26 ? "Enter hashtag here.." : "Enter handle here.."} className="form-control p-3" value={selectedFilterId == 26 ? hashtag : handle} onChangeHandler={(e) => this.onChangeHandler(e)} />
                                    </div>
                                    {((error && selectedFilterId == 26) || (handleError && selectedFilterId == 23)) && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required</span>}
                                </div>
                            </div>

                            {infoMsg ? <div className="ob-info-box"><FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'me-2'} />{infoMsg}</div> : null}
                        </>
                    }
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={isSubmitDisabled} />
                </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        accountId: state.addFeedReducer.selectedAccount,
        connectedAcc: state.addFeedReducer.connectedAcc,
    }
}

export default connect(mapStateToProps)(InstaFeed)